import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/store',
  name: 'Store',
  identify: 'store',
  component: LAYOUT,
  redirect: '/store/storeOrder',
  meta: {
    icon: 'material-symbols:storefront-outline',
    title: '订单管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'storeOrder',
      name: 'StoreOrder',
      identify: 'storeOrder',
      component: () => import('@/views/store/storeOrder/index.vue'),
      meta: {
        title: '门店订单管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'storeOrderDetail/:orderNum/:storeNum',
      name: 'StoreOrderDetail',
      identify: 'storeOrder',
      component: () => import('@/views/store/storeOrder/detail.vue'),
      meta: {
        title: '门店订单详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/store/storeOrder',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'storeOnlineOrder',
      name: 'StoreOnlineOrder',
      identify: 'storeOnlineOrder',
      component: () => import('@/views/store/storeOnlineOrder/index.vue'),
      meta: {
        title: '门店抖音订单管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'storeOnlineOrder/:orderNum/:storeNum',
      name: 'StoreOnlineOrderDetail',
      identify: 'storeOnlineOrder',
      component: () => import('@/views/store/storeOrder/detail.vue'),
      meta: {
        title: '门店抖音订单详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/store/storeOnlineOrder',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'storeAftersale',
      name: 'StoreAftersale',
      identify: 'storeAftersale',
      component: () => import('@/views/store/aftersale/index.vue'),
      meta: {
        title: '门店售后管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'capitalVerification',
      name: 'capitalVerification',
      identify: 'capitalVerification',
      component: () => import('@/views/business/capitalVerification/index.vue'),
      meta: {
        title: '验资查询',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'invoiceList',
      name: 'InvoiceList',
      identify: 'invoiceList',
      component: () => import('@/views/store/invoiceList/index.vue'),
      meta: {
        title: '发票列表',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
